'use client';

import { Anchor, anchorTag } from '@ni/nimble-components/dist/esm/anchor';
import { wrap } from '../utilities/react-wrapper';

export { anchorTag };
export { type Anchor };
export const NimbleAnchor = wrap(Anchor);
